import { Grid, makeStyles, Typography } from "@material-ui/core";
import { COLORS } from "../../theme/colors";
import { ShaDowBox } from "../boxes";

const useStyles = makeStyles(() => ({
  grid: {
    padding: "40px 0",
    borderRadius: 8,
    border: "1px dashed rgba(0, 0, 0, 0.12)",
    background: COLORS.darks[0][3],
  },
  title: {
    color: COLORS.darks[0][50],
  },
}));

export const NoTableData = ({ title, rootStyle }) => {
  const classes = useStyles();
  return (
    <ShaDowBox style={rootStyle}>
      <Grid container justifyContent="center" alignItems="center" className={classes.grid}>
        <Typography variant="h4" className={classes.title}>
          {title}
        </Typography>
      </Grid>
    </ShaDowBox>
  );
};
